module.exports = __webpack_public_path__ + "img/nicoleta-stan.798994de.jpg";